import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
	loginRegister: ['chapa', 'token'],
	loginLoading: [],
	loginSuccess: ['token', 'context'],
	loginUnauthorized : [],
	loginError: [],
	loginCancelled: [],
	logout: [],
	saveLogin: ['login'],
	deleteLogin: [],
	setClientId: ['clientId'],
});

/**
 * Handlers
 */
const INITIAL_STATE = {
	isLoading: false,
	login: null,
	token: null,
	status: 'logged_out',
	clientId: undefined,
	chapa: null,
	context: null
};

const setClientId = (state = INITIAL_STATE, action) => {
	return { ...state, clientId: action.clientId };
};

const loginRegister = (state = INITIAL_STATE, action) => {
	return { ...state, status: "login_register", isLoading: false, token: "Bearer " + action.token, context: null, chapa: action.chapa };
};

const loginLoading = (state = INITIAL_STATE, action) => {
	return { ...state, status: "logged_loading", isLoading: true };
};

const loginSuccess = (state = INITIAL_STATE, action) => {
	return { ...state, status: "logged_in", isLoading: false, token: "Bearer " + action.token, context: action.context };
};

const loginUnauthorized = (state = INITIAL_STATE, action) => {
	return { ...state, status: "login_unauthorized", isLoading: false, token: null, context: null };
};

const loginError = (state = INITIAL_STATE, action) => {
	return { ...state, status: "login_error", isLoading: false, token: null, context: null };
};

const loginCancelled = (state = INITIAL_STATE, action) => {
	return { ...state, status: "login_cancelled", isLoading: false, token: null, context: null };
};

const logout = (state = INITIAL_STATE, action) => {
	return INITIAL_STATE;
};

const saveLogin = (state = INITIAL_STATE, action) => {
	const newState = { ...state, login: action.login };
	return newState;
};

const deleteLogin = (state = INITIAL_STATE, action) => {
	const newState = { ...state, login: null };
	return newState;
};


/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
	[Types.LOGIN_REGISTER]: loginRegister,
	[Types.LOGIN_LOADING]: loginLoading,
	[Types.LOGIN_SUCCESS]: loginSuccess,
	[Types.LOGIN_ERROR]: loginError,
	[Types.LOGIN_UNAUTHORIZED]: loginUnauthorized,
	[Types.LOGIN_CANCELLED]: loginCancelled,
	[Types.LOGOUT]: logout,
	[Types.SAVE_LOGIN]: saveLogin,
	[Types.DELETE_LOGIN]: deleteLogin,
	[Types.SET_CLIENT_ID]: setClientId,
});
